import styled from "styled-components"
import { media } from "../../utils/utils"

export const LoginHeader = styled.div`
  width: 480px;
  max-width: 100%;
  height: 71px;
  margin: 61px auto 0 auto;
  padding-bottom: 10px;
  justify-content: space-between;
  background-color: ${props =>
    props.theme.colors.headerBGcolour
      ? props.theme.colors.headerBGcolour
      : "#ffffff"};
`

export const Wrapper = styled.div`
  ${media.md`
    padding: 0 10px;
  `};
`

export const Body = styled.div`
  padding-top: 32px;
  position: relative;

  ${media.md`
    padding: 29px 10px 0 ;  
  `};
`

export const Header = styled.header`
  display: flex;
  align-items: center;
  padding: 67px 0 40px 0;
  background-color: ${props => props.theme.colors.headerBGcolour};
  ${media.md`
    padding: 32px 10px 29px;
  `};
`

export const Separator = styled.div`
  height: 1px;
  background-color: ${props => props.theme.colors.border};
`
